import { FDHeadlineText, FDImage, FDStack } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useMobileLayout from 'Hooks/useMobileLayout';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { Carousel } from 'Packages/FacetDesign/Components/Experimental/Carousel';
import { BorderedTransparentBox } from 'Packages/FacetDesign/Components/Experimental/BorderedTransparentBox';
import { PersonalizedStrategyDataCard } from './PersonalizedStrategyDataCard';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg', align: 'center' },
  }, overrideReadOnly);

export const PersonalizedStrategyData = ({ resource }) => {
  const isMobile = useMobileLayout();

  const items = resource.attr('strategyItems')?.resources()?.list();
  const hasItems = items?.length > 0;
  if (!hasItems) { // if there are no items, hide the section
    return null;
  }

  const WrapperComponent = isMobile ? React.Fragment : BorderedTransparentBox;
  const wrapperProps = isMobile ? {} : {
    padding: 4,
    color: 'info',
    width: '100%',
  };

  return (
    <WrapperComponent {...wrapperProps}>
      <FDStack direction={'column'} spacing={4} alignItems={'center'}>
        {resource.withRelationship(fr.relationships.image.name,
          (rel) => <FDImage alt={''} src={rel.link('related').url()} rounded={false} />,
          () => null)}
        <MetaControl attrName={'title'} resource={resource} metaOverrideSet={metaOverrides} />
        <Carousel maxCardsVisible={isMobile ? 1.1 : 3.1}>
          {hasItems ? items.map((d) => <PersonalizedStrategyDataCard key={d.id()} resource={d} />) : null}
        </Carousel>
      </FDStack>
    </WrapperComponent>
  );
};

PersonalizedStrategyData.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
